<script setup>
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

defineProps({
  location: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <BasicBlock
    :icon="['fal', 'map-marker-alt']"
    :ariaDescription="$t('global.location')"
    :text="location"
  >
  </BasicBlock>
</template>
